
  var _styles = {
  "comprehensive-card-remark-container": {
    "marginTop": "0.16rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "comprehensive-card-remark-score-container": {
    "width": "0.58667rem",
    "height": "0.37333rem",
    "marginRight": "0.08rem",
    "backgroundColor": "rgb(0,64,153)",
    "borderRadius": "0.13333rem 0 0.17333rem 0.17333rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "comprehensive-card-remark-score": {
    "fontWeight": "400",
    "fontFamily": "MTfin-Regular2.0",
    "fontSize": "0.32rem",
    "color": "rgb(255,255,255)",
    "letterSpacing": 0,
    "lineHeight": "0.34667rem"
  },
  "comprehensive-card-remark-short-chinese": {
    "marginRight": "0.16rem",
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.32rem",
    "color": "rgb(0,64,153)",
    "letterSpacing": 0,
    "lineHeight": "0.4rem"
  },
  "comprehensive-card-remark-number": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(34,34,34)",
    "letterSpacing": 0,
    "lineHeight": "0.4rem"
  },
  "comprehensive-card-remark-avgScoreDesc": {
    "marginRight": "0.08rem",
    "maxWidth": "3.46667rem"
  },
  "comprehensive-card-remark-avgScoreDesc-text": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.32rem",
    "color": "rgb(0,64,153)",
    "letterSpacing": 0,
    "lineHeight": "0.4rem"
  }
};



  module.exports = _styles;
  